// vuexPersist.js

const vuexPersist = (store) => {
  // 在应用程序启动时从本地存储中获取状态
  if (localStorage.getItem('vuex')) {
    store.replaceState(JSON.parse(localStorage.getItem('vuex')));
  }

  // 监听状态的变化
  store.subscribe((mutation, state) => {
    // 将状态保存到本地存储中
    localStorage.setItem('vuex', JSON.stringify(state));
  });
};

export default vuexPersist;
